module.exports = __webpack_public_path__ + "img/level_five_hover.15806fb7.png";